import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MaterialSearch from '../MaterialSearch';
import OnlineStatus from '../chat/OnlineStatus';

class ChatUsers extends PureComponent {
  constructor(props) {
    super(props);

    this.limit = 7;

    this.handleShowAll = this.handleShowAll.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      showAll: false,
      terms: '',
    };
  }

  handleShowAll(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ showAll: true });
  }

  handleChange(event) {
    this.setState({ terms: event.target.value });
  }

  sortedUsers() {
    const { users, me } = this.props;

    const usersWithHistory = _.orderBy(_.reject(users, u => !u.createdAt), ['createdAt', 'online', 'firstName', 'lastName'], ['desc', 'asc', 'asc', 'asc']);
    const usersWithNoHistory = _.orderBy(_.reject(users, u => u.createdAt), ['online', 'firstName', 'lastName'], ['desc', 'asc', 'asc']);

    const allUsers = [...usersWithHistory, ...usersWithNoHistory];
    let filteredUsers = [];

    try {
      if (this.state.terms) {
        const search = new RegExp(this.state.terms, 'gi');
        allUsers.forEach((user) => {
          const fullName = `${user.firstName} ${user.lastName}`;
          if (user.firstName.match(search) || user.lastName.match(search) || user.username.match(search) || fullName.match(search)) {
            filteredUsers.push(user);
          }
        });
      } else {
        filteredUsers = allUsers;
      }
    } catch (e) {
      console.warn('Invalid search', e);
    }

    // Don't display dsisupport and current user
    return _.reject(filteredUsers, u => u.username === 'dsisupport' || u.id === me.id);
  }

  render() {
    const rooms = [];
    const sortedUsers = this.sortedUsers();

    sortedUsers.forEach((user) => {

      if (rooms.length >= this.limit && !this.state.showAll) {
        return;
      }

      // Use the username if the firstname and lastname are blank
      const displayName = user.firstName || user.lastName
        ? `${user.firstName} ${user.lastName}`
        : user.username;

      rooms.push(
        <div className="chat-user" key={user.id} onClick={() => { this.setState({ terms: '' }); this.props.open(user); }}>
          <OnlineStatus status={user.status} />
          {displayName}
          {user.lastMessage && (
            <div className="last-msg">{user.lastMessage}</div>
          )}
        </div>,
      );
    });

    if (!this.state.showAll && rooms.length >= this.limit) {
      rooms.push(
        <div
          key="chat-footer"
          className="chat-footer"
          onClick={this.handleShowAll}
          title={`Show ${sortedUsers.length - this.limit} more`}
        >
          <i className="zmdi zmdi-more" />
        </div>,
      );
    }

    return (
      <div className="chat-users">
        <div className="user-search">
          <MaterialSearch
            onChange={this.handleChange}
            placeholder="Search"
            results={sortedUsers.length}
            showResults={false}
            value={this.state.terms}
          />
        </div>
        {rooms}
      </div>
    );
  }
}

ChatUsers.propTypes = {
  me: PropTypes.object,
  open: PropTypes.func,
  users: PropTypes.array,
};

export default ChatUsers;
